/**
 * Every board the design draws, and the one path each is reached by.
 *
 * Nine tabs hold the app: Arrange runs the rules over a piece somebody already wrote, Library
 * finds a public original to arrange, Write runs the rules backwards over a progression typed
 * by hand, Book runs them forwards over the 314 examples, Rules is the eight predicates
 * themselves, Evidence is what makes any of the numbers believable, Editor is the notation
 * editor itself, which belongs to no rule at all, Lab is arranging with every choice Arrange
 * makes for the reader set by hand, and Read is a scan read by a machine, laid beside its page
 * and counted against the score it was printed from. The deeper screens hang off those nine
 * rather than sitting beside them, so the tab bar never grows and a back link always has
 * somewhere to go.
 *
 * Arranging is what the app is for, so it opens on Arrange: `/` is no board of its own and
 * sends the reader to `/arrange`, the path every library link already names.
 */

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import AppShell from "./components/AppShell";
import ArrangePage from "./pages/ArrangePage";
import BookPage from "./pages/BookPage";
import ComparePage from "./pages/ComparePage";
import EditorPage from "./pages/EditorPage";
import EvidencePage from "./pages/EvidencePage";
import ExportPage from "./pages/ExportPage";
import FiguresPage from "./pages/FiguresPage";
import InstrumentsPage from "./pages/InstrumentsPage";
import LabPage from "./pages/LabPage";
import LibraryPage from "./pages/LibraryPage";
import NotFoundPage from "./pages/NotFoundPage";
import ReadPage from "./pages/ReadPage";
import RulePage from "./pages/RulePage";
import RulesPage from "./pages/RulesPage";
import ScorePage from "./pages/ScorePage";
import VerdictPage from "./pages/VerdictPage";
import WritePage from "./pages/WritePage";
import { BriefProvider } from "./state/brief";

export default function App(): JSX.Element {
  return (
    <BrowserRouter>
      <BriefProvider>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/" element={<Navigate to="/arrange" replace />} />
            <Route path="/arrange" element={<ArrangePage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/write" element={<WritePage />} />
            <Route path="/score" element={<ScorePage />} />
            <Route path="/export" element={<ExportPage />} />
            <Route path="/book" element={<BookPage />} />
            <Route path="/book/:id" element={<VerdictPage />} />
            <Route path="/book/:id/compare" element={<ComparePage />} />
            <Route path="/rules" element={<RulesPage />} />
            <Route path="/rules/:predicate" element={<RulePage />} />
            <Route path="/instruments" element={<InstrumentsPage />} />
            <Route path="/editor" element={<EditorPage />} />
            <Route path="/evidence" element={<EvidencePage />} />
            <Route path="/evidence/figures" element={<FiguresPage />} />
            <Route path="/lab" element={<LabPage />} />
            <Route path="/read" element={<ReadPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BriefProvider>
    </BrowserRouter>
  );
}
